import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ConfirmBox = ({ onSuccess = async () => {}, isOpen, setIsOpen, onClose = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    setLoading(true);
    await onSuccess();
    setIsOpen(false);
    setLoading(false);
  };

  const handleCancel = () => {
    onClose();
    setIsOpen(false);
  };

  return (
    <Modal centered show={isOpen} onHide={handleCancel}>
      <Modal.Header className="popupheader delete pt-4">Delete Response</Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group pt-4 pb-5 m-0">
              <p className="popupheading delete p-0 m-0">Do you really want to delete selected response</p>
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center mt-2 mb-2 footerbtn">
                <button className="cancel" onClick={handleCancel}>
                  Cancel
                </button>
                {loading ? (
                  <button className="save">Deleting</button>
                ) : (
                  <button className="save" onClick={handleConfirm}>
                    Delete
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmBox;
